<div class="page-body">
  <div *ngIf="isError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">Oops! Something went wrong.</h3>
      <p class="info-text">Please try to reload the page or try again later.</p>
    </div>
  </div>

  <div *ngIf="!isError">
    <app-spinner></app-spinner>
  </div>
</div>
